export enum Column {
  Title = 'title',
  Date = 'date',
  BalanceAtTheBeginning = 'balanceAtTheBeginning',
  Revenue = 'revenue',
  Collected = 'collected',
  BalanceAtTheEnd = 'balanceAtTheEnd',
  EncashmentsCount = 'encashmentsCount',
  Action = 'action'
}
